import { render } from "./HeroiconsSolidOfficeBuilding.vue?vue&type=template&id=8a8d9248"
const script = {}

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidOfficeBuilding.vue"]])

export default __exports__